import { GRID_IMAGE, IMAGE, METRO, MOVIE, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../../constants/itemTypes'
import FlyerMovieContainer from '../cont/FlyerMovieContainer'
import getMetroFormatedDate from '../func/getMetroFormatedDate'
import Translation from '../../Translation/cont/Translation'
import getImageUrl from '../../../functions/getImageUrl'
import ImageWithFallback from '../../general/ImageWithFallback'

const ItemContentImage = ({itemData, onLoadImg}) => {
    if(!itemData) {
        return ''
    }

    const { payload, width, height, position_x, position_y} = itemData

    if(!payload) {
        return ''
    }

    const imgStyles = {
        width: width ? width : 'auto',
        height: height ? height : 'auto',
        objectFit: 'cover',
        objectPosition: `${position_x ? position_x : 'center' } ${position_y ? position_y : 'center'}`
    }

    return (
        <img src={payload.url} className="custom-content-image" onLoad={onLoadImg} style={imgStyles}/>
    )
}

const ItemContentText = ({itemData, colors}) => {
    if(!itemData) {
        return ''
    }

    const { payload } = itemData
    return payload && <div className={`${colors.chosen_font}-text custom-content-text`} dangerouslySetInnerHTML={{ __html: payload}} />
}

const ItemContentTitle = ({itemData, nextItem, colors})  => {
    if(!itemData)  {
        return ''
    }

    const { payload } = itemData

    const imageTitle = nextItem && nextItem.type !== 'text' ? ' next-item-is-image' : ''
    
    return payload && <div className={`${colors.chosen_font}-title custom-content-title` + imageTitle}>{payload}</div>
}

const ItemContentGridImage = ({itemData, moviesData, imagesData, colors}) => {
    if(!itemData)  {
        return ''
    }

    const { itemId, itemType, text, position } = itemData
    let imgUrl

    if(MOVIE === itemType) {
        const data = moviesData[itemId]

        if(!data  || !data.images || !data.images.poster) {
            return ''
        }

        imgUrl = data.images.poster.url
    } else if(IMAGE === itemType)  {
        const data = imagesData[itemId]

        if(!data || !data.payload) {
            return ''
        }

        imgUrl = data.payload.url
    }

    if(!imgUrl) {
        return ''
    }

    const { accent_color } = colors

    const coloredBackground = {
        backgroundColor: accent_color
    }

    const {finalImageURl, imageUrl } = getImageUrl(imgUrl, false, false, false, true, true)

    return (
        <div className='movie-poster-container'>
            {text && position && <div className={'movie-poster-attribute ' + position} style={coloredBackground}>{text}</div>}

            <div className='movie-poster–image'>
                <div>
                    {(finalImageURl || imageUrl) && <ImageWithFallback
                        src={finalImageURl}
                        srcFallback={imageUrl}
                        alt=""
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />}
                </div>
            </div>

            {text && position === 'both' && <div className={'movie-poster-attribute ' + position} style={coloredBackground}>{text}</div>}
        </div>
    )
}

const ItemContentMetro =({itemData, colors}) => {
    if(!itemData)  {
        return ''
    }

    const { title, description, date, image } = itemData
    const {finalImageURl, imageUrl } = getImageUrl(image && image.url, false, false, false, true, true)

    return (
        <div className="custom-content-metro">
            <div className="movie-information-wrapper">
                <div>
                    <div className="poster-format-item">
                        <div className="poster" style={{ borderRadius: colors.border_radius_posters }}>
                            {image && (finalImageURl || imageUrl) && <ImageWithFallback
                                src={finalImageURl}
                                srcFallback={imageUrl}
                                alt=""
                                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                            />}
                        </div>
                    </div>

                    {date && <div className={`date ${colors.chosen_font}-text-xsmall-black`}>
                        <Translation id="formik_date_from"/>
                        <span className="movie-title">{getMetroFormatedDate(new Date(date))}</span>
                    </div>}
                </div>

                <div className='inner-movie-information'>
                    {title && <div className="info-wrapper captions-item">
                        <h2 className={`movie-title ${colors.chosen_font}-text-small-black`}>{title}</h2>
                    </div>}

                    {description && <div className={`description ${colors.chosen_font}-text-xxsmall-light`}>{description}</div>}
                </div>
            </div>
        </div>
    )
}

const FlyerItemsList = ({
    listClassName='flyer-movie-list',
    items, 
    flyerData,
    cinemaData,
    movies,
    currentCinemaId,
    flyerServerData,
    week,
    colors,
    translation,
    iconsColor,
    performances,
    currentPeriodeStartDate,
    currentPeriodeEndDate,
    onLoadImg
}) => {
    if(!items || !items.order || 0 === items.order.length) {
        return ''
    }

    return (
        <div className={listClassName + (items && items.order ? ' items-' + items.order.length : '')}>
            {items.order.map((itemId, index) => {
                const item = items.items[itemId]
                const { id, type } = item                

                if(MOVIE_PERFORMANCES === type)  {
                    return <FlyerMovieContainer
                        key={index}
                        itemData={flyerData.moviePerformances.items[id]}
                        movies={movies}
                        cinemaData={cinemaData}
                        translation={translation}
                        currentCinemaId={currentCinemaId}
                        week={week}
                        colors={colors}
                        iconsColor={iconsColor}
                        hideTheatres={true}
                        performances={performances}
                        movieTimesDesktop="theater_sorted"
                        currentPeriodeStartDate={currentPeriodeStartDate}
                        currentPeriodeEndDate={currentPeriodeEndDate}
                    />
                } else if(GRID_IMAGE === type) {
                    return <ItemContentGridImage
                        key={index}
                        itemData={flyerData.gridImages.items[id]}
                        moviesData={movies}
                        imagesData={flyerServerData.imageElements.items}
                        colors={colors}
                        />
                    } else if(METRO === type) {
                        return <ItemContentMetro
                        key={index}
                        colors={colors}
                        itemData={flyerServerData.metroElements.items[id]}
                        />
                    } else if(IMAGE === type){
                        return <ItemContentImage
                        key={index}
                        itemData={flyerServerData.imageElements.items[id]}
                        onLoadImg={onLoadImg}
                        />
                    } else if(TEXT === type) {
                        return <ItemContentText
                        key={index}
                        colors={colors}
                        itemData={flyerServerData.textElements.items[id]}
                        
                        />
                    }  else if(TITLE === type) {
                        return <ItemContentTitle
                        key={index}
                        colors={colors}
                        itemData={flyerServerData.headlineElements.items[id]}
                        nextItem={items.items[items.order[index + 1]]}
                    />
                } else {
                    return ''
                }
            })}
        </div>
    )
}

export default FlyerItemsList